export const permissions = ($http: HttpApi) => ({
  delete: (id: string) => $http.$delete(`/permissions/${id}`),
  index: ({ objectId, objectType }: { objectId: string, objectType: string }) => $http.$get('/permissions', { query: { object_id: objectId, object_type: objectType } }),

  create: ({ objectId, objectType, grantees }: { objectId: string, objectType: string, grantees: any[] }) => $http.$post('/permissions', { body: { object_id: objectId, object_type: objectType, grantees } }),
});
